import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { LoadingView } from 'src/components/LoadingView';
import EventEmitter from 'src/utils/EventEmitter';
import { useMovementDetail } from './api/fetchScripts';
import './styles/ProductPopup.css';

const ProductPopupView = (props) => {
  const { data: orderDetail, isLoading } = useMovementDetail(props.customData.orderData.orderId)

  const onClosePopup = () => {
    EventEmitter.emit("show_custom_popup", { value: false });
  }


  const getDeliveryAddress = () => {
    var delivery_address = "";
    if (orderDetail) {
      delivery_address = orderDetail.transferToAddress;

      if (delivery_address) {
        delivery_address += ", " + orderDetail.transferToCity + ", " + orderDetail.transferToCounty + ", " + orderDetail.transferToPostCode;
      }
    }

    return delivery_address;
  }

  return (
    <div className="custom-popup-container-wrapper" style={{ height: "100%" }}>
      <div>
        <div className="custom-popup-container-wrapper-header">
          <div>Order</div>
          <div className="hide-mobile"><CloseIcon className="close-popup-icon" onClick={() => onClosePopup()} /></div>
        </div>
        {isLoading ?
          <LoadingView /> :
          <div className="custom-popup-container-wrapper-body">
            <div className="ack_movement_details" style={{ fontSize: "16px", color: "#333333" }}>
              <div><span style={{ fontWeight: "600" }}>Movement Order:</span> {orderDetail.orderId}</div>
              <div style={{ marginTop: "10px" }}><span style={{ fontWeight: "600" }}>Receiving Location:</span> {getDeliveryAddress()}</div>
            </div>

            <div className="orders-content-table-container">
              <div className="orders-content-table">

                <div className="orders-table-header">
                  <div className="child" style={{ "--width": '80%', "cursor": 'auto' }}>
                    <div id="modal-modal-description" style={{ fontSize: "14px", marginBottom: '8px', fontWeight: '600' }}>Product Name</div>
                  </div>
                  <div className="child" style={{ "--width": '20%', "cursor": 'auto' }}>
                    <div id="modal-modal-description" style={{ fontSize: "14px", marginBottom: '8px', fontWeight: '600' }}>Units</div>
                  </div>
                </div>
                <div className="orders-table-body movement">
                  {orderDetail.lineItems.map((product, index) => (
                    <div key={`prod-${index}`} className="list" style={{ padding: "10px 0 10px 5px" }}>
                      <div className="child" style={{ "--width": '80%' }}>
                        <div className="text">{product.description}</div>
                      </div>
                      <div className="child" style={{ "--width": '20%' }}>
                        <div className="text">+{product.quantity}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="custom-popup-container-wrapper-footer">
            </div>
          </div>
        }
      </div>
      <div className="custom-popup-container-wrapper-bottom-orders">
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-mobile-order" style={{ marginTop: '0px', cursor: "pointer" }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-desktop" style={{ cursor: "pointer", marginTop: '5px', justifyContent: 'center' }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
      </div>
    </div >
  );
}

export default ProductPopupView;